import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-picker',
  templateUrl: './app-language-picker.component.html',
  styleUrls: ['./app-language-picker.component.scss']
})

export class AppLanguagePickerComponent implements OnInit {

  selectedIndex: any;
  lang: any;
  supportLanguages = ['en', 'my', 'th', 'zh']; //'my_zawgyi'
  
  constructor(
    private translateService: TranslateService,
    private storage: LocalStorageService) { 
  
  }

  ngOnInit() {

    if (this.storage.retrieve('localLanguageIndex') == null) {
      this.storage.store('localLanguageIndex', 1);
      this.storage.store('localLanguage', "my"); 
      this.selectedIndex = 1;
    } 
    else
    {
      const storedIndex = this.storage.retrieve('localLanguageIndex');
      this.selectedIndex = storedIndex !== null ? Number(storedIndex) : 1;
    }  
    if (this.storage.retrieve('localLanguage') == null || this.storage.retrieve('localLanguage') == '') {
      this.storage.store('localLanguage', 'my');
    } else
    {
      this.translateService.setDefaultLang(this.storage.retrieve('localLanguage')); 
    }
    this.changeLanguage();
  }

  changeLanguage() {   
    this.lang = this.storage.retrieve('localLanguage');
    this.translateService.use(this.lang);
  }

  selectedLanguageCountry (lang: string, index: number) {
    this.selectedIndex = index;
    this.storage.store('localLanguage', lang); 
    this.storage.store('localLanguageIndex', this.selectedIndex);    
    this.changeLanguage();  
  }

}